export function formatDate (string, fullDate) {
  if (!string) {
    return
  }

  // let dateArray = string.split(/[^0-9]/)
  // let date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2], dateArray[3], dateArray[4], dateArray[5])
  let date = new Date(string)

  // let days = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
  // let months = (date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1

  if (fullDate) {
    // let hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    // let minutes = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()

    // return `${date.getFullYear()}-${months}-${days} ${hours}:${minutes}`
    return date.toLocaleString()
  } else {
    return date.toLocaleDateString()
    // return `${date.getFullYear()}-${months}-${days}`
  }
}
